<template>
  <v-layout column class="p-mb-4">
    <v-layout align-center justify-space-between row class="nav-base">
      <v-flex xs8>
        <v-toolbar-title>{{ title }}</v-toolbar-title>
      </v-flex>
      <v-layout xs2 justify-end>
        <Button
          v-if="showBack"
          label="Volver"
          style="color:#e65100"
          class="p-button-text p-mr-5"
          type="primary"
          icon="pi pi-arrow-left"
          @click="back()"
        />
      </v-layout>
    </v-layout>
    <v-flex *ng-if="headerInfo">
      <div class="header-info">
        <span class="info-text">{{headerInfo}}</span>
      </div>
    </v-flex>
  </v-layout>
  
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    showBack: {
      type: Boolean,
      default: false
    },
    headerInfo: {
      type: String,
      default: null
    },
    onBack: {
      type: Function
    },
  },
  methods: {
    back() {
      this.$router.back();
      if (this.onBack) {
        this.onBack();
      }
    }
  }
};
</script>

<style>
.nav-base {
  height: 42px;
}
.header-info {
  margin-left: 16px;
}
.info-text {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 1rem;
  letter-spacing: 0.6px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/base/NavBase.vue